import { Text } from '@chakra-ui/react'

import Image from '@/features/Services/components/atoms/Images/DPA'

import { TITLE_H1_STYLE, TITLE_H3_STYLE, PARAGRAPH_STYLE } from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'serviceDPA'

const TITLE = 'DPA'
const SUBTITLE = 'สัญญาประมวลผลข้อมูลส่วนบุคคล'

const PRIMARY_COLOR = '#D89CF6'
const SECONDARY_COLOR = '#FBF5FE'
const LINK_IMAGE = '/images/services/dpa/4.png'
const GRADIENT = `linear-gradient(0deg, rgba(216, 156, 246, 0.5) 0%, ${PRIMARY_COLOR} 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Data Processing
        <br />
        Agreement (DPA)
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        หากธุรกิจของคุณมีการว่าจ้างผู้ประมวลผลข้อมูลส่วนบุคคล เช่น บริษัท A
        ว่าจ้างให้ บริษัท B ทำการจัดการเงินเดือนให้พนักงาน (Payroll Service)
        ของบริษัท A โดยใช้ข้อมูลส่วนบุคคลของพนักงานบริษัท A ในกรณีนี้ ทั้งบริษัท
        A และ B จะต้องจัดทำ Data Processing Agreement
        หรือสัญญาประมวลผลข้อมูลส่วนบุคคลระหว่างกัน
        เพื่อควบคุมการดำเนินงานตามหน้าที่กำหนดความรับผิดชอบของผู้ประมวลผลข้อมูลส่วนบุคคลให้เป็นไปตาม
        PDPA
      </Text>
    ),
    image: '/images/services/dpa/dpa-header.svg',
    imageAspectRatio: 645 / 661,
    button: {
      label: 'สร้างสัญญาตอนนี้!',
      href: '/create/policy?template=dpa',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        DPA
        <br />
        จำเป็นอย่างไร ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        เพื่อควบคุมการดำเนินงานตามหน้าที่ของผู้ประมวลผล
        ข้อมูลส่วนบุคคลให้เป็นไปตาม พระราชบัญญัติ ข้อมูลส่วนบุคคล พ.ศ. 2562
        ผู้ประมวลผลข้อมูล ส่วนบุคคลจะต้องดำเนินงานตามที่ได้รับมอบหมายจาก
        ผู้ควบคุมข้อมูลส่วนบุคคล และผู้ควบคุมข้อมูล
        ส่วนบุคคลจะต้องจัดให้มีสัญญาประมวลผลข้อมูลส่วน
        บุคคลเพื่อกำหนดสิทธิและหน้าที่ในการคุ้มครองข้อมูล ส่วนบุคคล
      </Text>
    ),
    image: '/images/services/dpa/2.png',
    imageAspectRatio: 1,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        DPA
        <br />
        ครอบคลุมเรื่องอะไรบ้าง?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สัญญาการประมวลผลข้อมูลส่วนบุคคล
        มีการอธิบายถึงการส่งต่อหรือเปิดเผยข้อมูลส่วนบุคคลระหว่าง
        ผู้ควบคุมข้อมูลส่วนบุคคลและผู้ประมวลผลข้อมูลส่วนบุคคล
        โดยระบุชัดเจนถึงขอบเขตสิทธิและหน้าที่ของทั้งสองฝ่าย
        พร้อมระบุวัตถุประสงค์ในการส่งต่อเปิดเผยข้อมูลส่วนบุคคล
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับธุรกิจทุกรูปแบบ',
      'สอดคล้องกับ PDPA และ GDPR',
      'ได้รับทั้งฉบับภาษาไทยและภาษาอังกฤษ',
    ],
    image: <Image />,
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
